<template>
  <div>
    <div id="grid-list" v-on:click="tap">
      <div
        class="private"
        v-for="(grid, index) in grids"
        v-bind:key="index"
        :style="gridStyle(grid)"
      ></div>
      <div id="select-box" class="rectangle"></div>
    </div>

    <div id="buy-panel" v-if="currentGridId != null" :style="buyPanelStyle">
      <div class="card" style="min-width:200px">
        <div class="card-body">
          <h6 class="fw-bold">
            #{{ currentGridId }}
            <button
              type="button"
              class="btn-close float-end"
              aria-label="Close"
              v-on:click="cancelSelect"
            ></button>
          </h6>
          <p v-if="tokenInfo != null && tokenInfo.price == 0" v-cloak>
            {{ $t("invalidGrid") }}
          </p>
          <div v-else v-cloak>
            <clip-loader
              :loading="tokenInfo == null"
              :color="spinerColor"
            ></clip-loader>
            <div v-if="tokenInfo != null" v-cloak>
              <a
                v-if="tokenInfo.grid != null"
                :href="tokenInfo.grid.url"
                target="_blank"
                rel="nofollow"
              >
                <h6 class="text-center" v-cloak v-if="tokenInfo.grid.text">
                  {{ tokenInfo.grid.text }}
                </h6>
                <div class="d-flex justify-content-center">
                  <img
                    v-cloak
                    v-if="tokenInfo.grid.image_url"
                    :src="tokenInfo.grid.image_url"
                    @error="onLoadImageError"
                    class="image"
                  />
                </div>
              </a>

              <p class="card-text fw-light text-center mt-2">
                {{ $t("grid.currentPrice")
                }}<span class="num">{{ tokenInfo.price | ethFormat }} ETH</span
                ><br />
                {{ $t("grid.nextPrice")
                }}<span class="num"
                  >{{ tokenInfo.nextPrice | ethFormat }} ETH</span
                >
              </p>

              <ul
                class="mt-4 pt-2 list-unstyled border-top"
                v-cloak
                v-if="
                  account == tokenInfo.owner ||
                    (tokenInfo.grid != null &&
                      tokenInfo.grid.status == 'pending')
                "
              >
                <li
                  class="text-muted fw-light"
                  v-cloak
                  v-if="
                    account == tokenInfo.owner &&
                      tokenInfo.grid.status == 'normal'
                  "
                >
                  <span class="badge bg-light text-dark">{{
                    $t("grid.thisIsYourGrid")
                  }}</span>
                  <a href="/my#modify" class="btn btn-sm btn-primary">{{
                    $t("grid.modifyGrid")
                  }}</a>
                </li>
                <li
                  class="text-muted fw-light"
                  v-cloak
                  v-if="tokenInfo.grid.status == 'pending'"
                >
                  <small>{{ $t("grid.pendingTx") }}</small>
                </li>
              </ul>

              <div
                class="text-center"
                v-if="
                  account != tokenInfo.owner &&
                    tokenInfo.grid != null &&
                    tokenInfo.grid.status == 'normal'
                "
              >
                <button type="button" class="btn btn-primary" v-on:click="buy">
                  {{ $t("buy") }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  v-on:click="cancelSelect"
                >
                  {{ $t("cancel") }}
                </button>

                <ul class="mt-4 pt-2 list-unstyled border-top">
                  <li class="text-muted fw-light">
                    <small>{{ $t("buyTip1") }}</small>
                  </li>
                  <li class="text-muted fw-light">
                    <small>{{ $t("buyTip2") }}</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Grid = require("./Grid");
// const $ = require("jquery");

export default {
  props: [],
  mounted() {
    console.log("GridList mounted.");
    this.redBox = document.getElementById("select-box");
    this.$mainBox = $("#grid-list");

    const self = this;
    this.$eventBus.$on("contracts-ready", contract => {
      console.log("GridList contracts-ready");
      self.contract = contract;
      // self.fetchMaxTokenId();
    });

    this.$eventBus.$on("account-changed", account => {
      console.log("account-changed", account);
      self.account = account;
    });

    this.$eventBus.$on("buy-success", txHash => {
      console.log("buy-success", txHash);
      if (self.tokenInfo) {
        self.tokenInfo.grid.status = "pending";
      }
      self.currentGridId = null;
      // alert(this.$i18n.t("orderSubmitted"));
      self.$notify({
        group: "app",
        text: self.$i18n.t("grid.orderSubmitted"),
        type: "success"
      });
    });
  },
  data() {
    return {
      locale: "en",
      spinerSize: "8px",
      spinerColor: "#dc3545",

      account: null,
      contract: null,
      tokenInfo: null,
      // maxTokenId: 0,

      grids: [],
      currentGridId: null,

      redBox: null,
      $mainBox: null
    };
  },
  created: function() {
    // console.log("List created()", web3);
    const self = this;
    this.$http
      .get("/api/grids")
      .then(response => {
        self.grids = response.data.data;
      })
      .catch(e => {
        console.error(e);
      });

    // 转换格子序号到区域坐标
    this.convertGridToArea = function(grids) {
      // console.log(grids);
      if (grids.length == 0) {
        return false;
      }

      var minGrid = grids[0];
      var maxGrid = grids[grids.length - 1];

      var positionFrom = {
        x: ((minGrid % Grid.MAX_COLS) - 1) * Grid.SIZE.width,
        y: Math.floor(minGrid / Grid.MAX_ROWS) * Grid.SIZE.height
      };

      var positinTo = {
        x: (maxGrid % Grid.MAX_COLS) * Grid.SIZE.width,
        y: Math.floor(maxGrid / Grid.MAX_ROWS + 1) * Grid.SIZE.height
      };

      var size = {
        width: positinTo.x - positionFrom.x,
        height: positinTo.y - positionFrom.y
      };

      return {
        from: positionFrom,
        to: positinTo,
        size: size
      };
    };
  },
  computed: {
    buyPanelStyle: function() {
      const rect = Grid.rectById(this.currentGridId);
      let left = rect.x;
      let top = rect.y + rect.height;
      let right = 0;
      let bottom = 0;

      const $buyPanel = $("#buy-panel");

      if (left + $buyPanel.width() > Grid.AREA.width - Grid.SIZE.width) {
        right =
          Grid.SIZE.width +
          ($(window).width() - this.$mainBox.offset().left - Grid.AREA.width);
      } else if (left <= Grid.SIZE.width) {
        left = Grid.SIZE.width;
      }

      if (top + $buyPanel.height() > Grid.AREA.height - Grid.SIZE.height) {
        bottom =
          $(window).height() -
          this.$mainBox.offset().top -
          top +
          Grid.SIZE.height;
      } else if (top <= Grid.SIZE.height) {
        top = Grid.SIZE.height;
      }

      var result = {};
      if (right > 0) {
        result["right"] = right + "px";
      } else {
        result["left"] = left + this.$mainBox.offset().left + "px";
      }

      if (bottom > 0) {
        result["bottom"] = bottom + "px";
      } else {
        result["top"] = top + this.$mainBox.offset().top + "px";
      }

      return result;
    }
  },
  methods: {
    onLoadImageError: function(e) {
      console.log("onLoadImageError", e);
    },
    gridStyle: function(grid) {
      const color = "#" + grid.owner_address.substr(-6);
      const rect = Grid.rectById(grid.token_id);
      let style = {
        backgroundColor: color,
        left: rect.x + "px",
        top: rect.y + "px",
        width: rect.width + "px",
        height: rect.height + "px"
      };
      if (grid.image_url) {
        style.backgroundImage = "url(" + grid.image_url + ")";
        style.backgroundSize = "cover";
        style.backgroundRepeat = "no-repeat";
        style.backgroundPosition = "center center";
      }
      return style;
    },
    privateAreaSize: function(grids) {
      const area = this.convertGridToArea(grids);
      return {
        width: area.size.width + "px",
        height: area.size.height + "px"
      };
    },
    buy: function() {
      this.$eventBus.$emit("buy-grid", this.currentGridId);
    },
    cancelSelect: function() {
      this.currentGridId = null;
      this.redBox.style.visibility = "hidden";
    },
    getTokenIdByPosition: function(e) {
      const ev = e || window.event; //Moz || IE
      const position = {};

      if (ev.pageX) {
        //Moz
        position.x =
          ev.clientX + window.pageXOffset - this.$mainBox.offset().left;
        position.y =
          ev.clientY + window.pageYOffset - this.$mainBox.offset().top;
      } else if (ev.clientX) {
        //IE
        position.x =
          ev.clientX + window.pageXOffset - this.$mainBox.offset().left;
        position.y =
          ev.clientY + window.pageXOffset - this.$mainBox.offset().top;
      }

      return Grid.positionToId(position);
    },
    tap: function(e) {
      const tokenId = this.getTokenIdByPosition(e);
      // console.log("tap", tokenId);
      this.currentGridId = tokenId;
      const rect = Grid.rectById(tokenId);

      this.redBox.style.visibility = "visible";
      this.redBox.style.width = rect.width + "px";
      this.redBox.style.height = rect.height + "px";
      this.redBox.style.left = rect.x + "px";
      this.redBox.style.top = rect.y + "px";

      this.fetchTokenInfo(tokenId);
    },
    getGridByTokenId(tokenId) {
      for (var i = this.grids.length - 1; i >= 0; i--) {
        if (this.grids[i].token_id == tokenId) {
          return this.grids[i];
        }
      }
    },
    async fetchTokenInfo(tokenId) {
      const self = this;
      this.tokenInfo = null;

      await this.contract
        .allOf(tokenId)
        .then(function(info) {
          // console.log(info);
          self.tokenInfo = {};
          self.tokenInfo.tokenId = tokenId;
          self.tokenInfo.price = info._price;
          self.tokenInfo.nextPrice = info._nextPrice;
          self.tokenInfo.grid = self.getGridByTokenId(tokenId);
          self.tokenInfo.owner = info._owner;

          // console.log(self.tokenInfo);
          // console.log(self.tokenInfo.price == 0);
        })
        .catch(function(e) {
          console.log(e);
        });
    }
  }
};
</script>

<style>
#grid-list {
  width: 1000px;
  height: 1000px;
  border: 0px solid #ced4da;
  background-image: url("/images/grid-20.png");
  position: relative;
}
.rectangle {
  border: 1px solid #fff;
  position: absolute;
  visibility: hidden;
}
.private {
  position: absolute;
}
#buy-panel {
  /*line-height: 60px;*/
  /*background-color: #f5f5f5;*/
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  position: absolute;
  z-index: 1030;
}
#buy-panel .image {
  display: block;
  max-width: 400px;
  max-height: 400px;
  width: auto;
  height: auto;
}
</style>
